import { POST_EMPTY_DRAFT_REPORT_ERROR } from './';

export default error => dispatch =>
  dispatch({ type: POST_EMPTY_DRAFT_REPORT_ERROR, payload: { error } });
